export class EmailNotRecognisedError extends Error {
  constructor() {
    super("We're sorry, that email is not recognised. Please contact support@netpurpose.com.")
  }
}
